import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LoadingSpinner } from '../components/ui/LoadingSpinner';
import { usePermissions } from '../contexts/PermissionsContext';
import { isRestoreLastScreen } from '../hooks/useRememberLastScreen';

type PermissionRouteProps = {
  permission?: string;
  moduleCode?: string;
  requireWrite?: boolean;
  requireAdmin?: boolean;
};

export function PermissionRoute({
  permission,
  moduleCode,
  requireWrite = false,
  requireAdmin = false,
}: PermissionRouteProps) {
  const location = useLocation();
  const { isLoading, hasPermission, canAccessModule, canWriteModule, isOrganizationAdmin } =
    usePermissions();

  if (isLoading) {
    return <LoadingSpinner label="Carregando permissões..." />;
  }

  let allowed = false;
  if (requireAdmin) {
    allowed = isOrganizationAdmin;
  } else if (permission) {
    allowed = hasPermission(permission);
  } else if (moduleCode) {
    // Acesso controla entrada na UI/menu; escrita é exigida quando a rota é de edição exclusiva.
    allowed = requireWrite ? canWriteModule(moduleCode) : canAccessModule(moduleCode);
  }

  if (!allowed) {
    if (isRestoreLastScreen(location.state)) {
      return <Navigate to="/dashboard" replace />;
    }

    return <Navigate to="/access-denied" replace />;
  }

  return <Outlet />;
}
